module.exports = __webpack_public_path__ + "img/Miller-Learning-Center-t-27311-020.0e301778.jpg";